var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tooltip',{attrs:{"placement":_vm.placement,"target":_vm.target}},[_c('div',{staticClass:"tooltip-content"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }